import { render, staticRenderFns } from "./CampaignsHero.vue?vue&type=template&id=20de969a"
import script from "./CampaignsHero.vue?vue&type=script&lang=js"
export * from "./CampaignsHero.vue?vue&type=script&lang=js"
import style0 from "./CampaignsHero.vue?vue&type=style&index=0&id=20de969a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports